import type { FieldTypeTemplate } from '#layers/data-model/types/field-types/field-type';
import boolean from './boolean';
import color from './color';
import datetime from './datetime';
import file from './file';
import identifier from './identifier';
import json from './json';
import number from './number';
import relation from './relation';
import select from './select';
import slug from './slug';
import text from './text';
import user from './user';

const fieldTypes = { boolean, color, datetime, file, identifier, json, number, relation, select, slug, text, user };

const mappedTypes = Object.fromEntries(Object.values(fieldTypes as unknown as Record<string, FieldTypeTemplate>).map((type) => [type.id, type]));

export default mappedTypes;
